<template>
  <div>
    <!-- NOT USED? -->
    <div class="accordion-container clearfix">
      <div class="title clearfix">
        <wes-question-number v-bind:index="question.displayId"></wes-question-number>
        <p>{{ question.label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WesQuestionPanel',
  props: {
    question: Object
  }
};
</script>

<style scoped>
.accordion-container {
  width: 100%;
  /*margin: 2px 0;*/
  border: 2px solid;
  min-height: 50px;
  border-radius: 5px;
  background-color: #e0e0e0;
}
.accordion-container:hover {
  cursor: pointer;
}
.title {
  font-weight: bold;
  float: left;
  width: 90%;
  text-align: left;
  padding: 8px;
  background-color:#c5d3ed !important;
}
.title > p {
  margin: 0 0 0 5px;
  float: right;
  text-align: left;
  width: 96%;
  line-height: 32px;
  font-size: 16px;
}
</style>
